import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const flow = defineConnector({
  identifier: "flow",
  name: "Flow",
  tagLine: "Project management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.getflow\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your access token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Flow](https://www.getflow.com/), go to **Account Settings → API** and generate a personal access token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Organization ID",
          required: true,
          target: { kind: "configuration", field: "organizationId" },
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.getflow.com/v2/tasks",
  },
});
